module.exports = __webpack_public_path__ + "img/9_2.bc27de2b.png";